











import { ICategory, IRootCategory } from '@/contract/category.contract';
import { analyticsEventService } from '@/services/analytics/analytics-event.service';
import { AnalyticsEventCategory, AnalyticsEventName } from '@/services/analytics/analytics.contract';
import searchStore from '@/store/modules/search/searchStore';
import { Component, Vue } from 'vue-property-decorator';
import SearchCategoriesDesktop from './SearchCategoriesDesktop.vue';
import SearchCategoriesMobile from './SearchCategoriesMobile.vue';

@Component({
  components: {
    SearchCategoriesDesktop,
    SearchCategoriesMobile,
  },
})
export default class SearchCategories extends Vue {
  public get categories(): IRootCategory[] {
    return searchStore.state.categories.content;
  }

  public handleCategoryClicked(rootCategory: IRootCategory, category: ICategory): void {
    analyticsEventService.trackEvent(AnalyticsEventName.SearchOnCategory, AnalyticsEventCategory.Search, category.term);
    this.$router.push({
      name: this.Routes.Search,
      query: {
        c: category.term,
        r: rootCategory.term,
      },
    });
  }
}
